/**
 * Casa Branca Analytics
 *
 * Handles client-side event tracking for PostHog and Shopify analytics:
 * - Globo Form Builder submit listeners (trade application, contact forms)
 * - Form started tracking (focusin on inputs)
 * - Scroll depth milestones (25/50/75/90%)
 * - Delayed load mechanism for non-critical listeners
 *
 * Adapted from Maiden Home analytics.js for Casa Branca's designer journey.
 */

// ── Scroll Depth Tracking ──────────────────────────────────────────────────────

var scrollMilestones = { 25: false, 50: false, 75: false, 90: false };

function scrollHandler() {
  var scrollTop = window.scrollY;
  var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
  if (scrollHeight <= 0) return;
  var percent = Math.round((scrollTop / scrollHeight) * 100);

  var thresholds = [25, 50, 75, 90];
  for (var i = 0; i < thresholds.length; i++) {
    var t = thresholds[i];
    if (!scrollMilestones[t] && percent >= t) {
      scrollMilestones[t] = true;
      if (window.posthog) posthog.capture('scroll_depth', { percent: t });
      Shopify.analytics.publish('scroll', { percent: t });
    }
  }
}

window.addEventListener('load', function () {
  window.addEventListener('scroll', scrollHandler, { passive: true });
});

// ── Form Started Tracking ──────────────────────────────────────────────────────

window.formsStarted = [];

window.addEventListener('focusin', function (e) {
  if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') return;

  var form = e.target.closest('form');
  if (!form) return;
  if (form.classList.contains('facets__form') || form.classList.contains('mobile-facets')) return;

  var formId = form.id || form.dataset.id || form.action;
  if (window.formsStarted.indexOf(formId) > -1) return;
  window.formsStarted.push(formId);

  var name = '';
  if (form.action && form.action.indexOf('powerfulform') > -1 && window.Globo && Globo.FormBuilder && Globo.FormBuilder.forms && Globo.FormBuilder.forms[form.dataset.id]) {
    name = Globo.FormBuilder.forms[form.dataset.id].elements[0].label.en;
  }

  var properties = {
    id: formId,
    form_name: e.target.closest('[data-section-id')?.dataset.sectionId || name || 'Unknown Form',
    action: form.action
  };

  if (document.title && location.href.indexOf('/products/') > -1) {
    properties.product_title = document.title;
  }

  if (form.closest('.footer')) {
    properties.form_name = 'Email Capture';
  }

  if (window.posthog) posthog.capture('form_started', properties);
  Shopify.analytics.publish('form_started', properties);
});

// ── Globo Form Submit Listener (fires after delayedLoad) ───────────────────────

window.addEventListener('delayedLoad', function () {
  var gforms = document.querySelectorAll('.g-container');
  if (!gforms.length) return;

  gforms.forEach(function (form) {
    // Set hidden fields if present (link_location_id pattern)
    var hiddenFieldContainer = form.querySelector('.globo-form-control:has([data-label="link_location_id"])');
    if (hiddenFieldContainer) {
      var linkInput = hiddenFieldContainer.querySelector('input');
      if (linkInput) {
        linkInput.value = linkInput.closest('[data-section-id')?.dataset.sectionId || '';
      }
    }

    form.addEventListener('submit', function (e) {
      var userData = {};
      var formData = {};
      var firstTextAreaFound = false;

      e.target.querySelectorAll('input, select, textarea').forEach(function (input) {
        var labelEl = document.querySelector('label[for*="' + input.name + '"]');
        var keyLabel = (labelEl && labelEl.dataset.label) ? labelEl.dataset.label : input.name;

        if (keyLabel.indexOf('customer[') === -1) {
          if (keyLabel.toLowerCase().indexOf('email') > -1) {
            userData.email = input.value;
            formData.form_email = input.value;
          }
          if (keyLabel.toLowerCase().indexOf('phone') > -1) {
            userData.phone = input.value;
            formData.form_phone = input.value;
          }
          if (keyLabel.toLowerCase().indexOf('name') > -1) {
            userData.name = input.value;
            formData.form_user_name = input.value;
          }
          if (!firstTextAreaFound && input.tagName === 'TEXTAREA') {
            formData.form_notes = input.value;
            firstTextAreaFound = true;
          }
        }
        if (input.value) {
          formData[keyLabel] = input.value;
        }
      });

      if (document.title && location.href.indexOf('/products/') > -1) {
        formData.product_title = document.title;
      }

      // Delay to allow Globo validation to complete
      setTimeout(function () {
        var formName = '';

        // Try to get form name from section ID or Globo config
        var sectionEl = e.target.closest('[data-section-id');
        if (sectionEl && sectionEl.dataset.sectionId) {
          formName = sectionEl.dataset.sectionId;
        } else if (window.Globo && Globo.FormBuilder && Globo.FormBuilder.forms && Globo.FormBuilder.forms[form.dataset.id]) {
          formName = Globo.FormBuilder.forms[form.dataset.id].elements[0].label.en;
        } else {
          formName = 'Unknown Form';
        }

        formData.form_name = formName;
        formData.action = form.action;

        // Bail on validation errors
        if (e.target.querySelector('.has-error')) {
          Shopify.analytics.publish('form_error', {
            id: 'Globo Form ' + (form.dataset.id || ''),
            action: form.action,
            ...formData,
            ...userData
          });
          return;
        }

        // Identify user in PostHog with their email
        if (userData.email && window.posthog) {
          posthog.identify(userData.email, {
            email: userData.email,
            name: userData.name || '',
            phone: userData.phone || ''
          });
        }

        // Detect trade application specifically
        var isTrade = formName === 'Trade Form' || formName.toLowerCase().indexOf('trade') > -1;
        if (isTrade) {
          if (window.posthog) {
            posthog.capture('trade_application_submitted', {
              id: 'Globo Form ' + (form.dataset.id || ''),
              ...formData,
              ...userData
            });
          }
          Shopify.analytics.publish('trade_application_submitted', {
            id: 'Globo Form ' + (form.dataset.id || ''),
            ...formData,
            ...userData
          });
        }

        // Track form completion
        if (window.posthog) {
          posthog.capture('form_completed', {
            id: 'Globo Form ' + (form.dataset.id || ''),
            ...formData,
            ...userData
          });
        }
        Shopify.analytics.publish('form_completed', {
          id: 'Globo Form ' + (form.dataset.id || ''),
          ...formData,
          ...userData
        });
      }, 500);
    });
  });
});

// ── Delayed Load Mechanism ─────────────────────────────────────────────────────
// Fires 'delayedLoad' event after 5s or on first user interaction (min 3s).
// This defers non-critical analytics listeners to avoid blocking page load.

var delayedLoadTimeStamp = new Date().getTime();
var delayedLoadFullDelay = 5000;
var delayedLoadMinDelay = 3000;
var delayedLoadFired = false;
var delayedLoadTimeout = null;

window.addEventListener('load', function () {
  if (delayedLoadFired) return;
  delayedLoadTimeout = setTimeout(fireDelayedLoad, delayedLoadFullDelay);
});
window.addEventListener('touchstart', fireDelayedLoad);
window.addEventListener('mousemove', fireDelayedLoad);

function fireDelayedLoad() {
  if (delayedLoadFired) return;

  var currentTime = new Date().getTime();
  if (currentTime - delayedLoadTimeStamp < delayedLoadMinDelay) {
    delayedLoadTimeout = setTimeout(fireDelayedLoad, delayedLoadMinDelay - (currentTime - delayedLoadTimeStamp));
    window.removeEventListener('touchstart', fireDelayedLoad);
    window.removeEventListener('mousemove', fireDelayedLoad);
    return;
  }

  delayedLoadFired = true;
  window.dispatchEvent(new Event('delayedLoad'));
  window.removeEventListener('touchstart', fireDelayedLoad);
  window.removeEventListener('mousemove', fireDelayedLoad);
  clearTimeout(delayedLoadTimeout);
}
